'use strict';

var competizeAll = require('./competitors/competizeAll');

function onMustacheLoaded () {
  competizeAll(); // only when loading is done for regular crit
}

module.exports = onMustacheLoaded;
